import modalStyle from '@salesforce/retail-react-app/app/theme/components/base/modal'
import {remCalc} from '../../_utils'

export default {
    ...modalStyle,
    baseStyle: {
        modalOverlay: {background: 'background.overlay-modal'},

        closeIcon: {
            boxSize: {base: 'iconsSize.medium', lg: 'iconsSize.large'},
        },
        modalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: {base: '0 0 16px 0'},
        },
        modalHeaderCheck: {gap: remCalc(6), alignItems: 'center'},
        modalHeaderCartContainer: {
            // mb: remCalc(16),
        },
        modalHeaderTitle: {
            textStyle: 'body-medium',
            color: 'text.default',
            textAlign: 'left',
            fontWeight: 400,
        },
        checkIconBox: {
            boxSize: {base: 'iconsSize.medium'},
            color: 'text.success',
            marginRight: remCalc(8),
        },
        modalContent: {
            w: remCalc(688),
            p: ['xsmall.md', 'xsmall.md', 'xsmall.md', 'xsmall.lg'],
            paddingInline: ['xsmall.lg'],
            background: 'background.default',
            margin: '0',
            borderRadius: remCalc(8),
            maxHeight: '100%',
            minHeight: 'auto',
        },
        modalFooter: {
            flexDirection: 'column',
            w: '100%',
            justifyContent: 'center',
            p: '0',
            overflowY: 'auto',
        },
        cartProduct: {
            borderTop: 'small',
            borderBottom: 'small',
            borderColor: 'border.light',
            borderStyle: 'solid',
            padding: {base: `${remCalc(16)} 0`, lg: `${remCalc(20)} 0`},
            alignItems: 'center',
            gap: {base: remCalc(8), lg: remCalc(66)},
            flexDirection: {base: 'column', md: 'row', lg: 'row'},
            justifyContent: 'center',
            display: 'block',
        },
        productHeaderContainer: {
            justifyContent: 'center',
        },
        productHeader: {
            textStyle: 'head-xsmall',
            fontWeight: 500,
            color: 'text.default',
            textAlign: 'start',
        },
        productPricing: {
            textStyle: 'body-medium',
            fontWeight: 400,
            color: 'text.default',
            display: 'flex',
            flexDirection: 'column',
        },
        omnibusPricing: {
            color: 'text.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 400,
            textAlign: 'start',
        },
        pricingStack: {
            justifyContent: 'center',
            textAlign: 'end',
            gap: remCalc(12),
            flexWrap: 'wrap',
            //marginRight: remCalc(12),
        },
        productStack: {
            alignItems: {base: 'flex-start', md: 'center', lg: 'center'},
            justifyContent: 'flex-start',
            gap: {base: remCalc(8), md: remCalc(33), lg: remCalc(66)},
        },
        modalBody: {
            gap: {base: remCalc(16), lg: remCalc(24)},
            display: 'flex',
            flexDirection: 'column',
            p: '0',
            minHeight: 'fit-content',
            maxHeight: 'fit-content',
        },
        modalBodyCart: {
            gap: {base: remCalc(16), lg: remCalc(24)},
            display: 'flex',
            flexDirection: 'column',
            p: '0',
            minHeight: 'fit-content',
            overflow: 'none',
        },
        productButton: {
            w: 'full',
            minWidth: remCalc(140),
            _hover: {
                bg: 'button.background.primary-hover',
                textDecoration: 'none',
            },
        },
        shortDescriptionSubscription: {
            textStyle: 'body-xsmall',
        },
        longDescriptionSubscription: {
            textStyle: 'body-xsmall',
            listStyle: 'none',
        },
        buttonsStack: {
            w: 'full',
            gap: remCalc(24),
            justifyContent: 'center',
        },
        footerButtonStack: {
            w: 'full',
            gap: remCalc(16),
            justifyContent: 'center',
        },
        modalRecommendedTitle: {
            w: '100%',
            padding: `${remCalc(8)} 0`,
            borderTop: 'small',
            borderColor: 'border.light',
            borderStyle: 'solid',
            textStyle: 'body-small',
            color: 'text.default',
            fontWeight: 400,
        },
        productImageContainer: {
            minWidth: 'fit-content',
        },
        productImage: {
            boxSize: {base: remCalc(109), lg: remCalc(88)},
            //marginLeft: {lg: remCalc(12)},
            objectFit: 'cover',
        },
        productGrid: {
            flexDirection: 'column',
            overflowY: 'scroll',
            height: 'fit-content',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            gap: remCalc(8),
        },
        scrollContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(8),
            maxHeight: '100%',
            overflowY: 'auto',
        },
        productDetails: {
            flexDirection: {base: 'column', lg: 'row'},
            gap: {base: remCalc(8), lg: remCalc(66)},
            width: '100%',
            justifyContent: 'space-between',
        },
        pricingAlignment: {
            textAlign: {base: 'start', lg: 'end'},
            justifyContent: {base: 'flex-start', lg: 'flex-end'},
        },
        boldText: {
            fontWeight: '700',
        },
        modalRecommendedFull: {
            w: 'full',
            marginTop: {base: remCalc(16), lg: remCalc(24)},
        },
        recommendedProductImage: {
            boxSize: remCalc(79),
        },
        recommendedGrid: {
            templateColumns: {base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(2, 1fr)'},
            gap: {base: remCalc(16), lg: remCalc(24)},
        },
        recommendedAdd: {
            maxH: {base: remCalc(33), lg: remCalc(40)},
            padding: {base: `${remCalc(12)} ${remCalc(16)}`, lg: `${remCalc(18)} ${remCalc(24)}`},
        },
        stickyButton: {
            position: 'sticky',
            bottom: 0,
            zIndex: 1000,
            w: 'full',
            pt: remCalc(16),
            pb: {base: 0, lg: remCalc(16)},
            display: {base: 'flex', lg: 'none'},
        },
        recommendedProductGap: {
            gap: remCalc(8),
        },
        recommendedProductGapDouble: {
            gap: remCalc(16),
        },
        bundleFreeGiftLabel: {
            backgroundColor: '#0C2340',
            color: 'white',
            padding: '6px 8px',
            textStyle: 'body-xsmall',
            fontWeight: '700',
            w: 'fit-content',
            whiteSpace: 'nowrap',
        },
        bundleProductListPrice: {
            textDecoration: 'line-through',
            color: 'text.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 400,
        },
        bundleProductDetailPrice: {
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 400,
        },
        bundleProductPriceContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(3),
        },
    },
    variants: {
        searchModal: {
            pricingAlignment: {
                textAlign: {base: 'start', lg: 'start'},
                gap: remCalc(8),
            },
        },
    },
    parts: ['modalOverlay', 'pricingAlignment'],
}
